import React from 'react'
import './styles/problem.css'
import {db} from './firebase'


export default function Problem({problem ,email}) {
    //======================================================
    //
    //Removing data
    //
    //======================================================
    const removeData=()=>{
        db.collection(email).doc('data').collection('problems').doc(problem.contest_id + problem.prob_id).delete()
            .then(()=>window.location.reload())
        
    }

    return (
        <div className="container"> 
            <i class="material-icons" onClick={removeData}>delete_outline</i>
            <h3>{problem.contest_id + problem.prob_id}</h3>
            <h3 id='name'>{problem.name}</h3>
            <h3>{problem.rating}</h3>
            <a href={problem.url} target='_blank'> <i class="material-icons" id='link'>launch</i></a>
            
        </div>
        
    )
}
